// extracted by mini-css-extract-plugin
export default {"InvoiceBox":"Style_InvoiceBox__KJCer","TableBox":"Style_TableBox__IjJns","defaulttable":"Style_defaulttable__y3Iht"};